// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"571":"34ff90ce","973":"1c1102ea"}[chunkId] + ".css";
};